import {ChangeEvent, useState} from 'react';

const TextAreaInput = ({
  label,
  message,
  maxChar,
  required,
  onTextChange,
  value,
  placeholder,
}: {
  label: string;
  message?: string;
  maxChar?: number;
  required?: boolean;
  onTextChange?: (text: string) => void;
  value: string;
  placeholder?: string;
}) => {
  const [countChar, setCountChar] = useState<number>(0);

  const handleTextChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const text = e.target.value;

    setCountChar(text.length);

    onTextChange && onTextChange(text);
  };
  return (
    <div className="mb-6">
      <label
        htmlFor="item-description"
        className="font-display text-dark-navy mb-2 block dark:text-white"
      >
        {label}
        {required && <span className="text-red">*</span>}
      </label>
      {message ? (
        <p className="text-dark-grey dark:text-grey text-2xs mb-3">
          {message} {countChar} Of {maxChar} Characters Used.
        </p>
      ) : null}
      <textarea
        id="item-description"
        className="dark:bg-dark-navy w-full rounded-lg ring-0 focus:ring-0 border-light-grey dark:text-white focus:border-grey hover:border-grey"
        rows={4}
        required
        placeholder={placeholder}
        onChange={handleTextChange}
        maxLength={maxChar}
        value={value}
      ></textarea>
    </div>
  );
};

export default TextAreaInput;
